import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { DocumentServiceClient, DocumentServices, NServices, ServiceClient } from "src/app/web-api-client";
import { DocumentServiceCreationComponent } from "./documentService-creation/documentService-creation.component";
import { DocumentServiceEditComponent } from "./documentService-edit/documentService-edit.component";
import { SuccessModalComponent } from "../../../../modals/success-modal/success-modal.component";

@Component({
  selector: 'app-service-edit',
  templateUrl: './service-edit.component.html',
  styleUrls: ['./service-edit.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ServiceEditComponent implements OnInit {


  public onClose = new Subject<boolean>();
  public isLoaded = false;
  public editService: NServices;

  Form: FormGroup;
  public searchQuery: string = '';

  public documentServices: DocumentServices[] = [];
  public filteredDocumentServices: DocumentServices[] = [];

 public selectedDocumentService: DocumentServices;
  constructor(private fb: FormBuilder, public cdr: ChangeDetectorRef, public modalService: NgbModal, public documentServiceClient: DocumentServiceClient, public activeModal: NgbActiveModal, public client: ServiceClient) { }

  ngOnInit(): void {

    this.initializeForm();
    console.log(this.editService);
  }

  initializeForm() {

    this.documentServiceClient.getListByService(this.editService.idService).subscribe(docs => {
      this.documentServices = docs;
      this.filteredDocumentServices = docs;

      this.isLoaded = true;
      this.cdr.detectChanges();

    });

    this.Form = this.fb.group({
      serviceName: [this.editService.serviceName, Validators.required],
      uri: [this.editService.uri, Validators.required],
      yri: [this.editService.yri, Validators.required],
      isActive: [this.editService.isActive, Validators.required],
    });
  }

  public isSelected(service: DocumentServices): boolean {
    let result = this.selectedDocumentService != null && this.selectedDocumentService == service;

    return result;
  }

  public onUserSelected(service: DocumentServices) {
    if (this.isSelected(service)) {
      this.selectedDocumentService = null;
    }
    else {

      this.selectedDocumentService = service;
    }

    this.cdr.detectChanges();
  }


  filterServices() {
    if (this.searchQuery) {
      this.filteredDocumentServices = this.documentServices.filter(service =>
        service.documents.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredDocumentServices = this.documentServices;
    }
  }

  public onCreation(): void {

    const modalRef = this.modalService.open(DocumentServiceCreationComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.idService = this.editService.idService;
    modalRef.componentInstance.onClose.subscribe(r => {

      this.initializeForm();

    });
  }

  public onEdit(): void {


    let modalRef = this.modalService.open(DocumentServiceEditComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.documentService = this.selectedDocumentService;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.initializeForm();
    });
  }

  public onDelete(): void {

    this.documentServiceClient.remove(this.selectedDocumentService.idDocumentServices).subscribe(r => {
      this.initializeForm();
    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {


      this.editService.serviceName = this.Form.value.serviceName;
      this.editService.uri = this.Form.value.uri;
      this.editService.yri = this.Form.value.yri;
      this.editService.isActive = this.Form.value.isActive;



      this.client.update(this.editService).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }


  public GetCyrilicBool(value: boolean): string {
    return value ? 'Да' : 'Не';
  }

}
